// extracted by mini-css-extract-plugin
module.exports = {"quickNotes":"QuickNotes_quickNotes__1O7Zw","icon":"QuickNotes_icon__33ikL"};